<div class="d-flex justify-content-between align-items-center my-2">
  <div class="d-flex align-items-center">
    <img
      src="assets/images/random_assets/add_group.png"
      alt="add icon"
      class="add-group"
    />
    <div class="card-sub-heading ml-3 bold">Add to a group</div>
  </div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>
<div class="mt-3">
  <mat-form-field>
    <mat-select
    class="form-control matselect w-100"
    placeholder="Choose a group"
    formControlName=""
  >
    <mat-option> Group 01 </mat-option>
    <mat-option> Group 02 </mat-option>
    <mat-option class="select-btn">
      <div class="d-flex align-items-center">
        <span class="material-icons me-2 add"> add </span> Add New Group
      </div>
    </mat-option>
  </mat-select>
  </mat-form-field>
</div>
<div class="d-flex mt-4">
  <div class="col-md-12 d-flex justify-content-center">
    <button class="custom-btn w-100" type="button">Cancel</button>
    <button class="custom-btn w-100">Add to group</button>
  </div>
</div>
